import { PieChart, PieChartProps } from '../../../../renderers/pie-chart/pie-chart.component';
import { NIVALIZ_TRANSACTION_VOLUME_BY_SLOT_DIMENSION_DONUT_CHART_DEFINITION } from './nivaliz-transaction-volume-by-slot-dimension-donut-chart.definition';
import { NIVALIZ_TRANSACTION_VOLUME_BY_SLOT_DIMENSION_DONUT_CHART_MOCK_DATA } from './nivaliz-transaction-volume-by-slot-dimension-donut-chart.mock';

export const NivalizTransactionVolumeBySlotDimensionDonutChart = (props: PieChartProps) => (
    <PieChart
        {...props}
        variant='donut'
        showSliceValues
    />
);

NivalizTransactionVolumeBySlotDimensionDonutChart.definition = NIVALIZ_TRANSACTION_VOLUME_BY_SLOT_DIMENSION_DONUT_CHART_DEFINITION;
NivalizTransactionVolumeBySlotDimensionDonutChart.mockData = NIVALIZ_TRANSACTION_VOLUME_BY_SLOT_DIMENSION_DONUT_CHART_MOCK_DATA;
